import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Page,
  Layout,
  Card,
  FormLayout,
  TextField,
  Button,
  BlockStack,
  Text,
  InlineStack,
  Banner
} from '@shopify/polaris';
import { useAuth } from '../contexts/AuthContext';

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Get the page user was trying to access
  const from = location.state?.from?.pathname || '/workspace';

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const result = await login(email, password);
      
      if (result.success) {
        // Redirect to the page they were trying to access
        navigate(from, { replace: true });
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (error) {
      setError('An unexpected error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Page title="Login">
      <Layout>
        <Layout.Section>
          <div style={{ maxWidth: '400px', margin: '0 auto', paddingTop: '60px' }}>
            <Card>
              <BlockStack gap="loose">
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                  <Text variant="headingLg" fontWeight="bold">
                    Welcome Back
                  </Text>
                  <Text variant="bodyMd" color="subdued">
                    Sign in to your account
                  </Text>
                </div>

                {error && (
                  <Banner status="critical">
                    <p>{error}</p>
                  </Banner>
                )}

                <form onSubmit={handleSubmit}>
                  <FormLayout>
                    <TextField
                      label="Email"
                      type="email"
                      value={email}
                      onChange={setEmail}
                      autoComplete="email"
                      required
                      disabled={isLoading}
                    />

                    <TextField
                      label="Password"
                      type="password"
                      value={password}
                      onChange={setPassword}
                      autoComplete="current-password"
                      required
                      disabled={isLoading}
                    />

                    <Button
                      submit
                      variant="primary"
                      fullWidth
                      loading={isLoading}
                      disabled={!email || !password}
                    >
                      Sign In
                    </Button>
                  </FormLayout>
                </form>

                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                  <Text variant="bodySm" color="subdued">
                    Please contact your admin to get the credentials.
                  </Text>
                </div>
              </BlockStack>
            </Card>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  );
};
